import React from 'react';
import { extraVendorTrades, primaryVendorTrade, vendorCategoryOptions } from '../shared/vendorTrades';
import { vendorSoftShadow } from '../shared/vendorCardStyle';
import SearchableCategorySelect from './SearchableCategorySelect';

/**
 * Same toggle as the homeowner task cards: a button, aria-expanded,
 * and a chevron. Details render only while it is expanded.
 */
export default function TapToExpand({
  expanded,
  onToggle,
  controls,
  summary,
  children,
  leading = null,
  trailing = null,
  panelStyle = null,
  style = null,
}) {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', minWidth: 0 }}>
        {leading}
        <button
          type="button"
          className="task-card-toggle"
          aria-expanded={expanded}
          aria-controls={controls}
          onClick={onToggle}
          style={{
            flex: '1 1 auto',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '0.5rem',
            minWidth: 0,
            width: 'auto',
            margin: 0,
            padding: '0.15rem 0',
            background: 'transparent',
            border: 'none',
            boxShadow: 'none',
            color: 'inherit',
            textAlign: 'left',
            cursor: 'pointer',
            minHeight: '44px',
            ...style,
          }}
        >
          <span style={{ flex: 1, minWidth: 0 }}>{summary}</span>
          <span aria-hidden="true" style={{ fontSize: '1rem', lineHeight: 1, paddingTop: '0.2rem' }}>
            {expanded ? '\u25B4' : '\u25BE'}
          </span>
        </button>
        {trailing}
      </div>
      {expanded ? (
        <div id={controls} style={panelStyle || { marginTop: '0.9rem' }}>
          {children}
        </div>
      ) : null}
    </>
  );
}

export function VendorCategorySelect({ id, value, vendors, onChange, colors, extraOptions = [], compact = false, startOpen = false }) {
  return (
    <SearchableCategorySelect
      id={id}
      label="Category"
      value={value || ''}
      onChange={onChange}
      options={vendorCategoryOptions(vendors)}
      extraOptions={extraOptions}
      emptyLabel="All categories"
      colors={colors}
      compact={compact}
      startOpen={startOpen}
    />
  );
}

export function VendorTapCard({ vendor, expanded, onToggle, contact, children, accent }) {
  const trade = primaryVendorTrade(vendor);
  const extras = extraVendorTrades(vendor);
  const panelId = `vendor-details-${vendor.id || vendor.name}`;
  return (
    <TapToExpand
      expanded={expanded}
      onToggle={onToggle}
      controls={panelId}
      trailing={contact}
      summary={(
        <>
          <span style={{ display: 'block', fontSize: '1.05rem', fontWeight: 650, lineHeight: 1.35, overflowWrap: 'anywhere' }}>
            {vendor.name}
          </span>
          {trade ? (
            <span style={{ display: 'block', marginTop: '0.2rem', fontSize: '0.9rem', fontWeight: 650, color: accent, overflowWrap: 'anywhere' }}>
              {trade}
            </span>
          ) : null}
        </>
      )}
    >
      {extras.length > 0 ? (
        <p style={{ margin: '0 0 0.75rem', fontSize: '0.9rem' }}>
          Also: {extras.join(', ')}
        </p>
      ) : null}
      {children}
    </TapToExpand>
  );
}

export function callControlStyle(color) {
  return {
    flex: '0 0 auto',
    alignSelf: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '44px',
    padding: '0.45rem 0.95rem',
    borderRadius: '999px',
    border: 'none',
    background: 'rgba(89, 196, 196, 0.16)',
    color,
    fontWeight: 700,
    fontSize: '0.95rem',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
  };
}
